export enum IpStatus {
    ASSIGNED = "ASSIGNED",
    AVAILABLE = "AVAILABLE",
    IN_USE = "IN_USE"
}